export default {
    activities: [
		{
			activityId: 1,
			title: 'Video de bienvenida',
			description: '',
			type: 'video',
			icon: require('@/assets/img/menus_03.png'),
			url: 'VideoIntro_BBVA_L.mp4',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: null,
			parent: null,
		},
		{
			activityId: 2,
			title: 'Módulo 1',
			description: '',
			type: 'module',
			icon: require('@/assets/img/menus_03.png'),
			url: null,
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 1,
			parent: null,
		},
		{
			activityId: 3,
			title: 'Módulo 2',
			description: '',
			type: 'module',
			icon: require('@/assets/img/menus_03.png'),
			url: null,
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 2,
			parent: null,
		},
		{
			activityId: 4,
			title: 'Evaluación inicial',
			description: '',
			type: 'questions',
			icon: require('@/assets/img/menus_03.png'),
			url: null,
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: 4,
			afterOf: 1,
			parent: 2,
		},
		{
			activityId: 5,
			title: 'Unidad 1',
			description: '',
			type: 'gamelearning',
			icon: require('@/assets/img/menu_01.png'),
			// url: 'BBVA_M1_Unidad1_1022_SB',
			url: '2021/BBVA_M1_Unidad1_140521',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 4,
			parent: 2,
			hasEvaluation: true,
		},
		{
			activityId: 6,
			title: 'Unidad 2',
			description: '',
			type: 'gamelearning',
			icon: require('@/assets/img/menu_01.png'),
			url: '2022/BBVA_M1_Unidad2_17102022',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 5,
			parent: 2,
			hasEvaluation: true,
		},
		{
			activityId: 7,
			title: 'Unidad 3',
			description: '',
			type: 'gamelearning',
			icon: require('@/assets/img/menu_01.png'),
			url: '2021/BBVA_M1_Unidad3_140521',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 6,
			parent: 2,
			hasEvaluation: true,
		},
		{
			activityId: 8,
			title: 'Unidad 4',
			description: '',
			type: 'gamelearning',
			icon: require('@/assets/img/menu_01.png'),
			url: '2022/BBVA_M1_Unidad4_11mar22',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 7,
			parent: 2,
		},
		
		{
			activityId: 9,
			title: 'Video de bienvenida',
			description: '',
			type: 'video',
			icon: require('@/assets/img/menus_03.png'),
			url: 'certififcacion_m2.mp4',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 8,
			parent: 3,
		},
		{
			activityId: 10,
			title: 'Evaluación inicial',
			description: '',
			type: 'questions',
			icon: require('@/assets/img/menus_03.png'),
			url: null,
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: 6,
			afterOf: 9,
			parent: 3,
		},
		{
			activityId: 11,
			title: 'Unidad 1',
			description: '',
			type: 'gamelearning',
			icon:  require('@/assets/img/menu_01.png'),
			url: '2022/BBVA_M2_Unidad1_11mar22',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 10,
			parent: 3,
			hasEvaluation: false,
		},
		{
			activityId: 12,
			title: 'Unidad 2',
			description: '',
			type: 'gamelearning',
			icon:  require('@/assets/img/menu_01.png'),
			url: '2022/BBVA_M2_Unidad2_11mar22',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 11,
			parent: 3,
			hasEvaluation: false,
		},
		{
			activityId: 13,
			title: 'Unidad 3',
			description: '',
			type: 'gamelearning',
			icon:  require('@/assets/img/menu_01.png'),
			url: '2021/BBVA_M2_Unidad3_20092021',
			activityPoints: 0,
			evaluationPoints: 0,
			evaluation: null,
			afterOf: 12,
			parent: 3,
			hasEvaluation: false,
		},
	
	],
	codes: [
		{
			activities: [2,4,5,6,7,8],
			code: 'Analisis$Credito$2020$24'
		},
		{
			activities: [3,9,10,11,12,13],
			code: 'Analisis$Credito$2020$37'
		},
		
	]
}